import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["minWidth", "use", "children"];
import { useToolBarContext } from '../ToolBar/ToolBarContext';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFlex = styled.div.withConfig({
  displayName: "ToolBarGroup__StyledFlex",
  componentId: "gojyou-0"
})(({
  $use,
  $minWidth,
  $cssStyles,
  theme,
  $isInFilledToolbar
}) => {
  const calculatedMinWidth = typeof $minWidth === 'number' ? `${$minWidth}px` : $minWidth;
  return Object.assign({
    display: 'flex',
    alignItems: 'center',
    flexBasis: $minWidth ? calculatedMinWidth : '0%',
    maxInlineSize: '100%',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap',
    '> * + *': {
      marginInlineStart: theme.space['300']
    },
    // order specific styles
    '&:nth-child(2)': {
      flexShrink: 1,
      flexGrow: 1,
      justifyContent: 'center',
      '&:last-child': {
        flexGrow: 2,
        justifyContent: 'flex-end'
      }
    },
    '&:nth-child(3)': {
      '&:last-child': {
        justifyContent: 'flex-end'
      }
    }
  }, $use === 'filter-bar' && {
    flexBasis: 'auto',
    flexGrow: 9999,
    '&:last-child': {
      flexBasis: '400px',
      flexGrow: 1,
      justifyContent: 'flex-end'
    }
  }, $use === 'tabs' && {
    justifyContent: 'center',
    '&:nth-child(2)': {
      flexBasis: 'auto',
      minInlineSize: '50px'
    },
    '&:not(:nth-child(2))': {
      flexGrow: 0,
      flexShrink: 0
    },
    '&:nth-child(2):last-child, &:nth-child(1):last-child': {
      flexGrow: 1,
      justifyContent: 'center'
    }
  }, $use === 'dark' && {
    '&:nth-child(2)': {
      flexBasis: 'auto'
    }
  }, {
    // reset all heading styles for the toolbar, users can pass in margin props if they desire
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      margin: theme.space['0'],
      color: $isInFilledToolbar ? theme.color['text-core-on-fill-default'] : theme.color['text-core-default']
    }
  }, $cssStyles);
});
export { StyledFlex as StyledToolBarGroup };
export const ToolBarGroup = _ref => {
  let {
      minWidth,
      use = 'default',
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const toolBarContext = useToolBarContext();
  const isInFilledToolbar = (toolBarContext === null || toolBarContext === void 0 ? void 0 : toolBarContext.use) === 'default' || (toolBarContext === null || toolBarContext === void 0 ? void 0 : toolBarContext.use) === 'dark';
  return /*#__PURE__*/_jsx(StyledFlex, Object.assign({
    $minWidth: minWidth,
    $cssStyles: cssStyles,
    $use: use,
    $isInFilledToolbar: isInFilledToolbar
  }, domProps, {
    children: children
  }));
};